import React from 'react';
import Form from '../../../../../antd/form/Form/Form.jsx';
import { Form as AntForm } from 'antd';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField.jsx';
import { t } from '../../../../../../i18n.jsx';
import { number, required } from '../../../../../antd/form/FormValidation.js';
import FormDate from '../../../../../antd/form/FormDate/FormDate.jsx';
import { CollapseBlock } from '../../../../../common/index.jsx';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../../antd/form/FormButton/FormButton.jsx';
import FormRangeTimePicker from '../../../../../antd/form/FormRangeTimePicker/FormRangeTimePicker.jsx';
import FormNumberField from '../../../../../antd/form/FormNumberField/FormNumberField.jsx';
import FormRangeDatePicker from '../../../../../antd/form/FormRangeDatePicker/FormRangeDatePicker.jsx';
import { isUndefined } from 'lodash';
import dayjs from 'dayjs';

export const EduCourseDatesForm = ({
  onSubmit,
  initials = {},
  serverErrors = {},
}) => {
  const [form] = AntForm.useForm();

  const dates = AntForm.useWatch('dates', form);

  const isDateBetweenFromAndToDate = (current) => {
    if (isUndefined(dates) || isUndefined(current)) {
      return true;
    }

    const [fromDate] = dates;

    // Inclusive check: allow today and the start date itself
    // Compare by day granularity using normalized bounds
    const startBound = dayjs().startOf('day');
    const endBound = dayjs(fromDate).endOf('day');
    return current.isBetween(startBound, endBound, 'day', '[]');
  };

  const isDateAfterToday = (current) => {
    return current && current > dayjs().endOf('day');
  };

  React.useEffect(() => {
    // Map backend errors into form fields
    const fields = Object.entries(serverErrors || {}).map(
      ([name, messages]) => ({
        name,
        errors: Array.isArray(messages) ? messages : [String(messages)],
      }),
    );
    if (fields.length) {
      form.setFields(fields);
    }
  }, [serverErrors, form]);

  return (
    <CollapseBlock title={t('Informácie o termíne')}>
      <Form onFinish={onSubmit} initialValues={initials} form={form}>
        <FormTextField
          label={t('Miesto konania')}
          name="place"
          rules={[required(t)]}
          extra={t('Napríklad: miestnosť RA001, budova FRI')}
        />
        <FormNumberField
          label={t('Kapacita')}
          name="capacity"
          rules={[required(t), number(t, 1)]}
        />
        <FormRangeTimePicker
          label={t('Čas v rámci dňa')}
          name="time"
          placeholder={['8:00', '12:00']}
          rules={[required(t)]}
        />

        <FormRangeDatePicker
          label={t('Začiatok a koniec termínu')}
          name="dates"
          // disable date cell if date from is after today
          disabledDate={(current) => !isDateAfterToday(current)}
          rules={[
            required(t),
            {
              validator: (_, value) =>
                isDateAfterToday(value && value[0])
                  ? Promise.resolve()
                  : Promise.reject(
                      t('Začiatok musí byť neskôr ako dnešný dátum'),
                    ),
            },
          ]}
        />
        <FormDate
          label={t('Dátum uzávierky prihlášok')}
          name="date_registration_closed"
          // disable date cell if date is not between from and to date (inclusive of today and start)
          disabledDate={(date) => !isDateBetweenFromAndToDate(date)}
          extra={t(
            'Dátum musí byť najskôr dnešný dátum a zároveň najneskôr dátum začatia kurzu',
          )}
          rules={[
            required(t),
            {
              validator: (_, value) =>
                isDateBetweenFromAndToDate(value)
                  ? Promise.resolve()
                  : Promise.reject(
                      new Error(
                        t(
                          'Dátum musí byť dnes alebo neskôr a zároveň najneskôr v deň začiatku kurzu',
                        ),
                      ),
                    ),
            },
          ]}
        />
        <FormButtonsContainer>
          <FormButton submitOnClick={true}>{t('Uložiť')}</FormButton>
        </FormButtonsContainer>
      </Form>
    </CollapseBlock>
  );
};
